import React from "react";
import { apiGateway } from "../../utils/config";
import { RouteName } from "../../utils/route.utils";
import styles from "./styles.module.scss";
import Head from "next/head";
import Footer from "../../components/v3/components/Common/Footer";
import TAGS from "../../public/headJson.json";
import WebContainer from "../../components/v3/components/Common/Container";

const Category = ({ categories = [] }) => {
  return (
    <>
      <Head>
        <title>{TAGS.category.title}</title>
        <meta name="title" content={TAGS.category.title} />
        <meta name="description" content={TAGS.category.description} />
        <link rel="canonical" href={RouteName.category} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.category} />
        <meta property="og:title" content={TAGS.category.title} />
        <meta property="og:description" content={TAGS.category.description} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.category} />
        <meta property="twitter:title" content={TAGS.category.title} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />
        <meta
          property="twitter:description"
          content={TAGS.category.description}
        />
      </Head>

      <WebContainer>
        <div className="!grid grid-cols-2 gap-x-6 gap-y-5 !pt-20 pb-10 md:grid-cols-4 lg:!grid-cols-5 lg:!gap-y-6 lg:!pt-24">
          {categories?.map((item) => {
            return (
              <div key={item?.id}>
                <a href={`/category/${item?.slug}`} className="no-underline">
                  <div className="relative">
                    <img
                      src={item?.website_image}
                      alt="image"
                      className="mx-auto cursor-pointer"
                    />
                    <span className="!text-white no-underline absolute bottom-8 left-2.5 font-semibold tracking-wide text-[18px] break-words max-w-[65%] leading-[20px] lg:bottom-6 lg:!text-[20px]">
                      {item?.title}
                    </span>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </WebContainer>

      <div className={styles.footer}>
        <Footer footerPadding={"10px"} />
      </div>
    </>
  );
};

export default Category;

export async function getServerSideProps() {
  try {
    const url = `${apiGateway}/api/v1.3/categories/all/?page=1&page_size=2000`;
    const res = await fetch(url);
    const { categories } = await res.json();
    return {
      props: {
        categories,
      },
    };
  } catch (err) {
    return {
      notFound: true,
    };
  }
}
